<svg
  [ngStyle]="{
    width: size() + 'px',
    height: size() + 'px',
  }"
  [class]="'spinner-' + variant()"
  viewBox="0 0 100 100"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle
    [ngStyle]="{
      'stroke-width': strokeWidth() + 'px',
    }"
    cx="50"
    cy="50"
    r="45"
  />
</svg>
